import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Articles.module.scss";
import PathContext from "../../context/path";
import StatesContext from "../../context/states";
import MobileContext from "../../context/mobile";
import ArticleCard from '../ArticleCard/ArticleCard';
const Articles = () => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const { dataArticles } = states;
  const isMobile = useContext(MobileContext);
  const [isOpen, setOpen] = useState(false);
  const refHidden = useRef(null);
  const refHiddenInner = useRef(null);
  const [data, setData] = useState(null);
  useEffect(() => {
    const hidden = refHidden.current;
    const hiddenInner = refHiddenInner.current;
    if (hiddenInner !== null) {
      hidden.style.height = isOpen ? `${hiddenInner.offsetHeight}px` : 0;
    }
  }, [isOpen]);
  useEffect(()=>{
    if(dataArticles !== null){
      let array = [...dataArticles];
      array.sort((a,b)=>b.id - a.id);
      setData(array);
    }
  },[dataArticles]);
  if (data === null) return null;
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.header}>

          <div className={styles.info}>
            <div className={styles.title}>Читайте статьи о нас </div>
            {!isMobile && data.length > 2 ?
              <div className={styles.btn} onClick={() => { setOpen(!isOpen) }}>
                {!isOpen ? 'Показать больше' : 'Свернуть'}
              </div>

              : null}
          </div>
          <div className={styles.list}>
            {data.length > 0 ?
              <div className={styles.col}>
                <ArticleCard data={data[0]} size={isMobile ? 'big' : null} />
              </div>
              : null
            }

            {data.length > 1 ?
              <div className={styles.col}>
                <ArticleCard data={data[1]} size={isMobile ? 'big' : null} />
              </div>
              : null
            }
            {/* <ArticleCard data={data[1]}/> */}
          </div>
        </div>

        {!isMobile && data.length > 2 ?
          <div className={styles.hidden} ref={refHidden}>
            <div className={styles.hidden__inner} ref={refHiddenInner}>
              <div className={styles.col}>
                <ArticleCard data={data[2]} size={'big'} />
              </div>
              {data.length > 3 ?
                <div className={styles.col}>
                  <ArticleCard data={data[3]} size={'big'} />
                </div>
                : null
              }
            </div>
          </div>
          : null}
      </div>
    </>
  );

}

export default Articles;
